import { useEffect } from 'react';
import { directoryClient } from 'shared/domain/directory/directoryClient';
import { areDirectoryIdsEqual } from 'shared/domain/directory/directoryIds';

interface DirectoryNavigationTarget {
  currentDirectoryId: string;
  enterDirectory: (directoryId: string, directoryName: string) => void;
  invalidateDirectory?: (directoryId: string) => void;
}

interface UseAutoEnterUploadedDirectoryParams {
  isOpen: boolean;
  browser: DirectoryNavigationTarget;
}

export function useAutoEnterUploadedDirectory({
  isOpen,
  browser,
}: UseAutoEnterUploadedDirectoryParams): void {
  useEffect(() => {
    if (!isOpen) return;

    return directoryClient.onUploaded((event) => {
      if (event.error || !event.data?._id) {
        return;
      }

      const parentId = event.data.parentId ?? '';
      if (!areDirectoryIdsEqual(parentId, browser.currentDirectoryId)) {
        return;
      }

      browser.invalidateDirectory?.(parentId);
      browser.enterDirectory(event.data._id, event.data.name ?? '');
    });
  }, [
    isOpen,
    browser.currentDirectoryId,
    browser.enterDirectory,
    browser.invalidateDirectory,
  ]);
}
